import _slicedToArray from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import React, { useEffect } from "react";
var CONTAINER_ID = "commento";
var SCRIPT_ID = "commento-script";
var COMMENTO_URL = "https://cdn.commento.io/js/commento.js";

var insertScript = function insertScript(src, id, parentElement, dataAttributes) {
  var script = window.document.createElement("script");
  script.async = true;
  script.src = src;
  script.id = id;
  Object.entries(dataAttributes).forEach(function (_ref) {
    var _ref2 = _slicedToArray(_ref, 2),
        key = _ref2[0],
        value = _ref2[1];

    if (value === undefined) {
      return;
    }

    script.setAttribute("data-".concat(key), value.toString());
  });
  parentElement.appendChild(script);
};

var removeScript = function removeScript(id, parentElement) {
  var script = window.document.getElementById(id);

  if (script) {
    parentElement.removeChild(script);
  }
};

var Commento = function Commento(_ref3) {
  var id = _ref3.id,
      cssOverride = _ref3.cssOverride,
      autoInit = _ref3.autoInit,
      noFonts = _ref3.noFonts,
      hideDeleted = _ref3.hideDeleted,
      pageId = _ref3.pageId;
  useEffect(function () {
    if (!window) {
      return;
    }

    var document = window.document;

    if (document.getElementById("commento")) {
      insertScript(COMMENTO_URL, SCRIPT_ID, document.body, {
        "css-override": cssOverride,
        "auto-init": autoInit,
        "no-fonts": noFonts,
        "hide-deleted": hideDeleted,
        "page-id": pageId
      });
    }

    return function () {
      return removeScript(SCRIPT_ID, document.body);
    };
  }, [id]);
  return React.createElement("div", {
    key: id,
    id: CONTAINER_ID
  });
};

export default Commento;